module.exports = __webpack_public_path__ + "static/media/personal_pronoun_2nd_img.942ff188.JPG";